import reduceReducers from "reduce-reducers";
import * as schemaSelectors from "./schema_selectors";
export * from "./schema";
import schemaReducer from "./schema";
import resourceMetadataReducer from "./resource_metadata";

const schema = reduceReducers(schemaReducer, resourceMetadataReducer);
export { schemaSelectors, schema };
